import axiosInstance from "../../../api/axiosInstance";

// ===== CATEGORIES =====
export const fetchCategories = async () => {
  try {
    console.log("[DailySentenceService] Fetching categories");
    const res = await axiosInstance.get("/public/daily-sentences/categories");
    console.log("[DailySentenceService] Categories response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[DailySentenceService] Categories failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchCategoryById = async (id) => {
  try {
    console.log("[DailySentenceService] Fetching category by id:", id);
    const res = await axiosInstance.get(`/public/daily-sentences/categories/${id}`);
    console.log("[DailySentenceService] Category detail response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[DailySentenceService] Category detail failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

// ===== SENTENCES =====
export const fetchDailySentences = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    console.log("[DailySentenceService] Fetching sentences, params:", cleaned);
    const res = await axiosInstance.get("/public/daily-sentences", { params: cleaned });
    console.log("[DailySentenceService] Sentences response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[DailySentenceService] Sentences failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchDailySentenceById = async (id) => {
  try {
    console.log("[DailySentenceService] Fetching sentence by id:", id);
    const res = await axiosInstance.get(`/public/daily-sentences/${id}`);
    console.log("[DailySentenceService] Sentence detail response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[DailySentenceService] Sentence detail failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

// ===== OPTIONS =====
export const fetchSentenceOptions = async () => {
  try {
    console.log("[DailySentenceService] Fetching options");
    const res = await axiosInstance.get("/public/daily-sentences/options");
    console.log("[DailySentenceService] Options response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[DailySentenceService] Options failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch options" };
  }
};
